import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { TownNodeConnection, TownNodeEdge } from '../../../schema';
import { townDropdownQuery } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class MultipleTownDropdown extends React.Component<Props, State> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      name: '',
    };
  }

  fetch = (name: string) =>
    new Promise<TownNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string, stateList: string }, { data: { allTowns: TownNodeConnection } }>(
        API_URL,
        { name, stateList: this.props.stateList },
        townDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allTowns.edges),
        (e) => reject(e),
      );
    })

  render() {
    const { name } = this.state;
    const { value: id } = this.props;
    return (
      <AutoCompleteAsync<TownNodeEdge>
        {...this.props}
        mode='multiple'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<TownNodeEdge>, 'data'> {
  stateList: string;
  mode: 'multiple';
  value: TownNodeEdge[];
  onChange: (value: TownNodeEdge[]) => void;
}

interface State {
  name: string;
}
